import {useEffect} from "react";

const StateBar = ({data, name, width, xpadding, legendaitems, slider}) => {
    useEffect(() => {
        document.getElementById(name + "text").innerHTML = name + " (No Data)"
        const canvas = document.getElementById(name);
        const context = canvas.getContext("2d");
        canvas.width = 750;
        canvas.height = 350;
        const xoffset = xpadding;
        const yoffset = 60;
        const gap = 10
        const ysize = 75
        const legenda = 30
        const legendaitem = 15
        let legendasize = 0

        if (data && data[0] && data[0].data[0] && data[0].data[0]._start) {
            document.getElementById(name + "text").innerHTML = name
            canvas.height = yoffset + (gap + ysize) * data.length + legenda + 10;
            canvas.width = width;

            context.strokeStyle = "#999999";
            context.lineWidth = 1;
            context.font = "Bold 20px Arial";

            context.beginPath()

            for (let i = 0; i < 11; i++) {
                context.moveTo((canvas.width - xoffset) / 10 * i + xoffset, yoffset / 2);
                context.lineTo((canvas.width - xoffset) / 10 * i + xoffset, canvas.height - yoffset / 2 - legenda - 10);
            }

            context.stroke()

            const start = Date.parse(data[0].data[0]._start)
            const diff = (Date.parse(data[0].data[0]._stop) - start) / 10;

            for (let i = 0; i < 10; i++) {
                context.fillText(new Date(diff * i + start).toTimeString().split(" ")[0].slice(0, 5), (canvas.width - xoffset) / 10 * i + xoffset - 30, canvas.height - legenda - 10);
            }

            legendaitems.forEach((item, index) => {
                context.beginPath();

                context.lineWidth = legendaitem
                context.strokeStyle = item.color

                context.moveTo(gap * (index + 1) + legendasize, canvas.height - legenda / 2 - 10)
                context.lineTo(gap * (index + 1) + legendasize, canvas.height - 10)

                context.fillText(item.name, gap * (index + 2) + legendasize, canvas.height - 10)

                legendasize = legendasize + context.measureText(item.name).width + gap * 3

                context.stroke()
            })

            context.lineWidth = 2

            data.map((item, index) => {
                context.fillText(item.name, 0, 75 + (ysize + gap) * index);

                context.beginPath()

                context.moveTo(xoffset, 80 + (ysize + gap) * index);

                if (item.data && item.data[0]) {

                    item.data.forEach((data, i) => {
                        if (data._value >= 0 && data._value != null) {
                            context.stroke()
                            context.beginPath()

                            context.strokeStyle = item.colors.find((d)=> d.value >= data._value).color

                            context.moveTo((canvas.width - xoffset) / item.data.length * i + xoffset, yoffset / 2 + (ysize + gap) * index);
                            context.lineTo((canvas.width - xoffset) / item.data.length * i + xoffset, yoffset / 2 + ysize * (index + 1) + gap * index);
                        }
                    })
                }
            })

            data.map((item, index) => {
                if (slider >= 0) {
                    const height = canvas.height
                    const sliderwidth = 1001
                    const padding = 10
                    const rowsize = 25
                    const cube = 15
                    const dataWidth = (width - xpadding - 1) / sliderwidth * slider + xpadding;
                    const dataHeight = (ysize + gap) * index + 1 + 35
                    const value = item.data[Math.floor(item.data.length / sliderwidth * slider)]._value
                    let time = item.data[Math.floor(item.data.length / sliderwidth * slider)]._time
                    time = new Date(time).toString()
                    time = time.slice(4, 24)
                    const color = value === null ? "white" : item.colors.find((d)=> d.value >= value).color
                    const itemName = value === null ? "Null" : item.colors.find((d)=> d.value >= value).name
                    const boxWidth = context.measureText(item.name).width + context.measureText(itemName).width + 80 > context.measureText(time).width ? context.measureText(item.name).width + context.measureText(itemName).width + 80 : context.measureText(item.name).width + 180
                    const boxHeight = 65
                    const negativeY = dataHeight + boxHeight > height ? -boxHeight : 0
                    const negativeX = dataWidth + boxWidth > width ? -boxWidth : 0
                    const boxY = dataHeight + negativeY
                    const boxX = dataWidth + negativeX

                    context.beginPath()
                    context.strokeStyle = "red";
                    context.fillStyle = "white";
                    context.lineWidth = 2;

                    context.moveTo(dataWidth, yoffset / 2);
                    context.lineTo(dataWidth, height - yoffset);

                    context.stroke()

                    context.beginPath()

                    context.strokeStyle = "black";
                    context.lineWidth = 1;
                    context.globalAlpha = 0.85

                    context.roundRect(boxX, boxY, boxWidth, boxHeight, 10);

                    context.stroke()
                    context.fill()

                    context.fillStyle = "black";
                    context.globalAlpha = 1

                    context.fillText(time, boxX + padding, boxY + rowsize * 2);

                    context.fillText(item.name+ ":", boxX + padding, boxY + rowsize);

                    context.fillText(itemName, boxX + padding * 2 + 20 + context.measureText(item.name).width, boxY + rowsize);

                    context.fillStyle = color

                    context.fillRect(boxX + padding * 2 + context.measureText(item.name).width, boxY + rowsize - cube, cube, cube);
                }
            })
        }
    }, [data, slider])


    return (
        <div className={"bg-white shadow p-4 h-fit rounded-md"}>
            <h1 id={name + "text"} className={"text-gray-600 font-bold"}></h1>
            <canvas className={"w-full"} id={name}></canvas>
        </div>
    )
}

export default StateBar;